import { LOGGER_ENABLE, SENTRY_ENABLE, isProd } from '@shared/env';
import { isExpectFiltered } from './filter';
import { handleSentryCaptureError } from './sentry';
import { LOGGER_SPACIAL_SYMBOL } from '../config';

type MD = LOGGER_SPACIAL_SYMBOL;

// 保存原始 console 方法，供 logger 在生产环境中调用
const originalConsole = {
	log: console.log.bind(console),
	info: console.info.bind(console),
	warn: console.warn.bind(console),
	error: console.error.bind(console),
	debug: (console as any).debug ? (console as any).debug.bind(console) : console.log.bind(console),
};

// 线上环境（构建或部署判定），屏蔽全局 console 输出，只保留通过 logger 输出
if (isProd) {
	// 用空函数替换常用的控制台方法，避免线上直接使用 console 打印
	console.log = () => {};
	console.info = () => {};
	console.warn = () => {};
	console.error = () => {};
	try {
		(console as any).debug = () => {};
	} catch (_) {
		// ignore
	}
}

class Logger {
	/**
	 * 暂时仅支持打印错误并上报 Sentry
	 * @param module 异常发生的模块
	 * @param desc 异常的描述
	 * @param error 错误实例
	 */
	error(module: string, desc: string, error: unknown) {
		if (LOGGER_ENABLE) {
			originalConsole.error('[A1.LOGGER][ERROR]', module, desc, error);
		}

		if (SENTRY_ENABLE && !isExpectFiltered(error)) {
			handleSentryCaptureError(module, desc, error);
		}
	}

	/**
	 * 用来打印需要保留在项目中的 log
	 * @param md 模块标识
	 * @param args 额外参数
	 */
	log(md: MD, ...args: unknown[]) {
		if (!LOGGER_ENABLE) return;
		// 始终使用原始 console 输出，以便在生产环境仍能打印通过 logger 的日志
		originalConsole.log(md, ...args);
	}

	info(md: MD, ...args: unknown[]) {
		if (!LOGGER_ENABLE) return;
		originalConsole.info(md, ...args);
	}

	warn(md: MD, ...args: unknown[]) {
		if (!LOGGER_ENABLE) return;
		originalConsole.warn(md, ...args);
	}

	debug(md: MD, ...args: unknown[]) {
		if (!LOGGER_ENABLE) return;
		originalConsole.debug(md, ...args);
	}
}

const logger = new Logger();
export default logger;
